import { render } from "./AlertCard.vue?vue&type=template&id=0bbb5fc5&ts=true"
import script from "./AlertCard.vue?vue&type=script&lang=ts"
export * from "./AlertCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__